import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import ListLayout from "@/components_v3/layout/ListLayout.vue";
import { downloadExcelFile, showServerError } from "@/utils";
import DownloadButton from "@/components-UI/buttons/DownloadButton.vue";
import { getBillsExport } from "@/api/payout";
import ReloadButton from "@/components-UI/buttons/ReloadButton.vue";
import BillsTable from "@/components_v3/affiliate/bills/BillsTable.vue";
import BillsFilters from "@/components_v3/affiliate/bills/BillsFilters.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BillsList',
  setup(__props) {

const billsTableEl = ref<BillsTable | null>(null);

const isExportLoading = ref(false);
const exportBills = async () => {
    try {
        isExportLoading.value = true;
        const params = billsTableEl.value?.getParams();
        const file = await getBillsExport(params);
        downloadExcelFile(file, 'Платежи', 'xls');
    } catch (err) {
        showServerError(err, 'Не удалось скачать выгрузку');
    } finally {
        isExportLoading.value = false;
    }
};

const reload = () => {
    billsTableEl.value?.getBills();
};

return { __sfc: true,billsTableEl, isExportLoading, exportBills, reload, ListLayout, DownloadButton, ReloadButton, BillsTable, BillsFilters }
}

})